import { GRAPH_DATATYPE } from "../../../../constants/app-constant";
import { qualitativeEnvConfig } from "../../../../constants/api-endpoint";

export const getCorrectParamDetails = (paramGraphData) => {

    let url = "";
    let graphs_data = "";
    let publication_type = "";
    let media_type = -1;
    let category = "";
    let subtype = "";
    let indextype = "";
    let extratype = "";

    let newtype = "";


    //SOV - Entity Level
    if (
        paramGraphData === GRAPH_DATATYPE.SOVEntityRankingOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityRankingPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityRankingPrintOnline
    ) {
        category = "sov";
        subtype = "entity";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVEntityRankingOnline:
                graphs_data = "twolevelonline";
                break;
            case GRAPH_DATATYPE.SOVEntityRankingPrint:
                graphs_data = "twolevelprint";
                break;
            case GRAPH_DATATYPE.SOVEntityRankingPrintOnline:
                graphs_data = "twolevelprintonline";
        }
        url = qualitativeEnvConfig.generalize2levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityTonalityPrintOnline
    ) {
        category = "sov";
        subtype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVEntityTonalityOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVEntityTonalityPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVEntityTonalityPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVEntityTrendPrintOnline
    ) {
        category = "sov";
        subtype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVEntityTrendOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVEntityTrendPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVEntityTrendPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    //SOV - Journalist Level
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVJournalistRankingOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistRankingPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistRankingPrintOnline
    ) {
        category = "sov";
        subtype = "journalist";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVJournalistRankingOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVJournalistRankingPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVJournalistRankingPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline
    ) {
        category = "sov";
        subtype = "journalist";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVJournalistTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVJournalistTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVJournalistTrendPrintOnline
    ) {
        category = "sov";
        subtype = "journalist";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVJournalistTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVJournalistTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVJournalistTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    //SOV - Keyword Level
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVKeywordRankingOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordRankingPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordRankingPrintOnline
    ) {
        category = "sov";
        subtype = "keywords";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVKeywordRankingOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVKeywordRankingPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVKeywordRankingPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline
    ) {
        category = "sov";
        subtype = "keywords";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVKeywordTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVKeywordTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVKeywordTrendPrintOnline
    ) {
        category = "sov";
        subtype = "keywords";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVKeywordTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVKeywordTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVKeywordTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    //SOV - Publication Level
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVPublicationRankingOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationRankingPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationRankingPrintOnline
    ) {
        category = "sov";
        subtype = "publication";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVPublicationRankingOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVPublicationRankingPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVPublicationRankingPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline
    ) {
        category = "sov";
        subtype = "publication";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVPublicationTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVPublicationTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVPublicationTrendPrintOnline
    ) {
        category = "sov";
        subtype = "publication";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVPublicationTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.SOVPublicationTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVPublicationTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    //SOV - City Level
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVCityRankingOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVCityRankingPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVCityRankingPrintOnline
    ) {
        category = "sov";
        subtype = "city";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVCityRankingPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.SOVCityRankingOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.SOVCityRankingPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVCityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVCityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVCityTonalityPrintOnline
    ) {
        category = "sov";
        subtype = "city";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVCityTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVCityTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.SOVCityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SOVCityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SOVCityTrendPrintOnline
    ) {
        category = "sov";
        subtype = "city";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SOVCityTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SOVCityTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    //Thematic - Entity Level
    if (
        paramGraphData === GRAPH_DATATYPE.ThematicEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntitySOVPrintOnline
    ) {
        category = "thematic";
        subtype = "thematic";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicEntitySOVOnline:
                graphs_data = "threelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicEntitySOVPrint:
                graphs_data = "threelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicEntitySOVPrintOnline:
                graphs_data = "threelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline
    ) {
        category = "thematic";
        subtype = "thematic";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicEntityTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicEntityTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicEntityTrendPrintOnline
    ) {
        category = "thematic";
        subtype = "thematic";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicEntityTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicEntityTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicEntityTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    //Thematic - Journalist Level
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline
    ) {
        category = "thematic";
        subtype = "journalist";
        indextype = "journalist"
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicJournalistSOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicJournalistSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline
    ) {
        category = "thematic";
        subtype = "journalist";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicJournalistTonalityOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicJournalistTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicJournalistTrendPrintOnline
    ) {
        category = "thematic";
        subtype = "journalist";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicJournalistTrendOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicJournalistTrendPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicJournalistTrendPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    //Thematic - Keyword Level
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline
    ) {
        category = "thematic";
        subtype = "keywords";
        indextype = "keywords"
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicKeywordSOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicKeywordSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline
    ) {
        category = "thematic";
        subtype = "keywords";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicKeywordTonalityOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicKeywordTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline
    ) {
        category = "thematic";
        subtype = "keywords";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicKeywordTrendOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicKeywordTrendPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    //Thematic - Publication Level
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationSOVPrintOnline
    ) {
        category = "thematic";
        subtype = "thematic";
        indextype = "publication";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicPublicationSOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicPublicationSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicPublicationSOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTonalityPrintOnline
    ) {
        category = "thematic";
        subtype = "publication";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicPublicationTonalityOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicPublicationTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicPublicationTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicPublicationTrendPrintOnline
    ) {
        category = "thematic";
        subtype = "publication";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicPublicationTrendOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.ThematicPublicationTrendPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicPublicationTrendPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    //Thematic - City Level
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicCitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicCitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicCitySOVPrintOnline
    ) {
        category = "thematic";
        subtype = "city";
        indextype = "city";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicCitySOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.ThematicCitySOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.ThematicCitySOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicCityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicCityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicCityTonalityPrintOnline
    ) {
        category = "thematic";
        subtype = "city";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicCityTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicCityTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicCityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.ThematicCityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicCityTrendPrintOnline
    ) {
        category = "thematic";
        subtype = "city";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicCityTrendPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.ThematicCityTrendPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.ThematicNewEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.ThematicNewEntitySOVPrint
    ) {
        category = "";
        subtype = "";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.ThematicNewEntitySOVOnline:
                graphs_data = "thematicreportthemewiseonline";
                break;
            case GRAPH_DATATYPE.ThematicNewEntitySOVPrint:
                graphs_data = "thematicreportthemewiseprint";
                break;
        }
        url = qualitativeEnvConfig.thematicreportthemewise;
    }
    //Geolocation - Entity Level
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "zone";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationEntitySOVOnline:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntitySOVPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline:
                graphs_data = "fivelevelprint";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationNewEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationNewEntitySOVPrint
    ) {
        category = "";
        subtype = "";
        indextype = "";
        media_type = 0;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationNewEntitySOVOnline:
                graphs_data = "geolocationreptcityboth";
                break;
            case GRAPH_DATATYPE.GeolocationNewEntitySOVPrint:
                graphs_data = "geolocationreptcityboth";
                break;
        }
        url = qualitativeEnvConfig.geolocationcitywisearticle;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "tonality";
        extratype = "geoloctonality";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationEntityTonalityOnline:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntityTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "trend";
        extratype = "geoloctrend";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationEntityTrendOnline:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntityTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    //Geolocation - Keyword Level
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "keywords";
        extratype = "sovzonekeywords";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationKeywordSOVOnline:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordSOVPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "keywords";
        extratype = "geokeytonality";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationKeywordTonalityOnline:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordTonalityPrint:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline:
                graphs_data = "sevenlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize7levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "keywords";
        extratype = "geokeytrend";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationKeywordTrendOnline:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordTrendPrint:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline:
                graphs_data = "sevenlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize7levelreport;
    }
    //Geolocation - Publication Level
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "publication";
        extratype = "sovzonepublication";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationPublicationSOVOnline:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationSOVPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        console.log("index type is keywords in geolocation tonality");
        indextype = "keywords";
        extratype = "geopubltonality";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationPublicationTonalityOnline:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationTonalityPrint:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline:
                graphs_data = "sevenlevelprint";
                break;
        }
        url = qualitativeEnvConfig.generalize7levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline
    ) {
        category = "geoLocation";
        subtype = "state";
        indextype = "publication";
        extratype = "geopubltrend";
        media_type = 2;
        switch (paramGraphData) {
            case GRAPH_DATATYPE.GeolocationPublicationTrendOnline:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationTrendPrint:
                graphs_data = "sevenlevelprint";
                break;
            case GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline:
                graphs_data = "sevenlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize7levelreport;
    }
    //Publication - Entity Level
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntitySOVPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "publication";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationEntitySOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationEntitySOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationEntitySOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize4levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "tonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationEntityTonalityOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.PublicationEntityTonalityPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationEntityTrendPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "trend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationEntityTrendOnline:
                graphs_data = "fivelevelonline";
                break;
            case GRAPH_DATATYPE.PublicationEntityTrendPrint:
                graphs_data = "fivelevelprint";
                break;
            case GRAPH_DATATYPE.PublicationEntityTrendPrintOnline:
                graphs_data = "fivelevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    //Publication - Keyword Level
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "keywords";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationKeywordSOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationKeywordSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "tonality";
        extratype = "pubtonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationKeywordTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationKeywordTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "trend";
        extratype = "pubtrend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationKeywordTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationKeywordTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    //Publication - Journalist Level
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "journalist";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationJournalistSOVOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationJournalistSOVPrint:
                graphs_data = "fourlevelprint";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "tonality";
        extratype = "journalisttonality";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationJournalistTonalityOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationJournalistTonalityPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline
    ) {
        category = "publication";
        subtype = "genre";
        indextype = "trend";
        extratype = "journalisttrend";
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationJournalistTrendOnline:
                graphs_data = "fourlevelonline";
                break;
            case GRAPH_DATATYPE.PublicationJournalistTrendPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline:
                graphs_data = "fourlevelprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize6levelreport;
    }
    // Publication New Level
    else if (
        paramGraphData === GRAPH_DATATYPE.PublicationNewEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.PublicationNewEntitySOVPrint
    ) {
        category = "";
        subtype = "";
        indextype = "";
        media_type = 0
        switch (paramGraphData) {
            case GRAPH_DATATYPE.PublicationEntitySOVOnline:
                graphs_data = "pubreptgenresplitindexboth";
                break;
            case GRAPH_DATATYPE.PublicationEntitySOVPrint:
                graphs_data = "pubreptgenresplitindexboth";
                break;
        }
        url = qualitativeEnvConfig.publicationreptgenresplitindex;
    }
    // Sentiment Entity Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SentimentEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentEntityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentEntityTrendOnline:
                graphs_data = "SentimentClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrint:
                graphs_data = "SentimentClientCompetitortrendprint";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "sentiment";
        subtype = "tonality";
        indextype = "trend";

    }

    //sentiment new entity all 
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentNewEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentNewEntitySOVOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentNewEntitySOVOnline:
                graphs_data = "sentimentcomptetitionindexonline";
                break;
            case GRAPH_DATATYPE.SentimentNewEntitySOVPrint:
                graphs_data = "sentimentcomptetitionindexprint";
                break;
        }
        url = qualitativeEnvConfig.sentimenteportcomptetitionindex;
        category = "";
        subtype = "";

    }

    // Sentiment Entity SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentEntitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentEntitySOVOnline:
                graphs_data = "SentimentClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.SentimentEntitySOVPrint:
                graphs_data = "SentimentClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.SentimentEntitySOVPrintOnline:
                graphs_data = "SentimentClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
        category = "sentiment";
        subtype = "tonality";

    }



    // Sentiment Journalist Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentJournalistTrendOnline:
                graphs_data = "SentimentJournalistTrendonline";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrint:
                graphs_data = "SentimentJournalistTrendprint";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrintOnline:
                graphs_data = "SentimentJournalistTrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
        category = "sentiment";
        subtype = "journalist";
        indextype = "trend";

    }

    // Sentiment Journalist SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentJournalistSOVOnline:
                graphs_data = "SentimentJournalistSOVonline";
                break;
            case GRAPH_DATATYPE.SentimentJournalistSOVPrint:
                graphs_data = "SentimentJournalistSOVprint";
                break;
            case GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline:
                graphs_data = "SentimentJournalistSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "sentiment";
        subtype = "journalist";
        indextype = "journalist"

    }

    // Sentiment Publication Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentPublicationTrendOnline:
                graphs_data = "SentimentPublicationTrendonline";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrint:
                graphs_data = "SentimentPublicationTrendprint";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrintOnline:
                graphs_data = "SentimentPublicationTrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
        category = "sentiment";
        subtype = "publication";
        indextype = "trend";

    }

    // Sentiment Publication SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentPublicationSOVOnline:
                graphs_data = "SentimentPublicationSOVonline";
                break;
            case GRAPH_DATATYPE.SentimentPublicationSOVPrint:
                graphs_data = "SentimentPublicationSOVprint";
                break;
            case GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline:
                graphs_data = "SentimentPublicationSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "sentiment";
        subtype = "tonality";
        indextype = "publication"

    }

    // Sentiment City Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SentimentCityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentCityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentEntityTrendPrint:
                graphs_data = "SentimentCityTrendprint";
                break;
            case GRAPH_DATATYPE.SentimentEntityTrendPrintOnline:
                graphs_data = "SentimentCityTrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
        category = "sentiment";
        subtype = "city";
        indextype = "trend";

    }

    // Sentiment City SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentCitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentCitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentCitySOVPrint:
                graphs_data = "SentimentCitySOVprint";
                break;
            case GRAPH_DATATYPE.SentimentCitySOVPrintOnline:
                graphs_data = "SentimentCitySOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "sentiment";
        subtype = "city";
        indextype = "city"

    }

    // Sentiment Keyword Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentKeywordTrendOnline:
                graphs_data = "SentimentKeywordTrendonline";
                break;
            case GRAPH_DATATYPE.SentimentKeywordTrendPrint:
                graphs_data = "SentimentKeywordTrendprint";
                break;
            case GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline:
                graphs_data = "SentimentKeywordTrendprintOnline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
        category = "sentiment";
        subtype = "keywords";
        indextype = "trend";

    }

    // Sentiment Keyword SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SentimentKeywordSOVOnline:
                graphs_data = "SentimentKeywordSOVonline";
                break;
            case GRAPH_DATATYPE.SentimentKeywordSOVPrint:
                graphs_data = "SentimentKeywordSOVprint";
                break;
            case GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline:
                graphs_data = "SentimentKeywordSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "sentiment";
        subtype = "keywords";
        indextype = "keywords"

    }


    // Spokesperson Entity Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonEntityTrendOnline:
                graphs_data = "SpokespersonClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.SpokespersonEntityTrendPrint:
                graphs_data = "SpokespersonClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline:
                graphs_data = "SpokespersonClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson4levelreport;
        category = "spokesperson";
        subtype = "spokesperson";
        indextype = "trend";

    }

    // Spokesperson Entity SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonEntitySOVOnline:
                graphs_data = "SpokespersonClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.SpokespersonEntitySOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline:
                graphs_data = "SpokespersonClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson3levelreport;
        category = "spokesperson";
        subtype = "spokesperson";

    }


    // Spokesperson Journalist Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonJournalistTrendOnline:
                graphs_data = "SpokespersonClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.SpokespersonJournalistTrendPrint:
                graphs_data = "SpokespersonClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline:
                graphs_data = "SpokespersonClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson5levelreport;
        category = "spokesperson";
        subtype = "journalist";
        indextype = "trend";
    }

    // Spokesperson Journalist SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonJournalistSOVOnline:
                graphs_data = "SpokespersonClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.SpokespersonJournalistSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline:
                graphs_data = "SpokespersonClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson4levelreport;
        category = "spokesperson";
        subtype = "spokesperson";
        indextype = "journalist";
    }

    // Spokesperson Topic Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonTopicTrendOnline:
                graphs_data = "SpokespersonClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.SpokespersonTopicTrendPrint:
                graphs_data = "SpokespersonClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline:
                graphs_data = "SpokespersonClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson5levelreport;
        category = "spokesperson";
        subtype = "topic";
        indextype = "trend";

    }

    // Spokesperson Topic SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonTopicSOVOnline:
                graphs_data = "SpokespersonClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.SpokespersonTopicSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline:
                graphs_data = "SpokespersonClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson4levelreport;
        category = "spokesperson";
        subtype = "spokesperson";
        indextype = "topic"

    }

    // Spokesperson Profile Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonProfileTrendOnline:
                graphs_data = "SpokespersonClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.SpokespersonProfileTrendPrint:
                graphs_data = "SpokespersonClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline:
                graphs_data = "SpokespersonClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson5levelreport;
        category = "spokesperson";
        subtype = "profile";
        indextype = "trend";

    }

    // Spokesperson Profile SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.SpokespersonProfileSOVOnline:
                graphs_data = "SpokespersonClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.SpokespersonProfileSOVPrint:
                graphs_data = "fourlevelprint";
                break;
            case GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline:
                graphs_data = "SpokespersonClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.spokesperson4levelreport;
        category = "spokesperson";
        subtype = "spokesperson";
        indextype = "profile"

    }



    // Journalist Entity Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistEntityTrendOnline:
                graphs_data = "JournalistClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.JournalistEntityTrendPrint:
                graphs_data = "JournalistClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.JournalistEntityTrendPrintOnline:
                graphs_data = "JournalistClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "journalist";
        subtype = "journalist";
        indextype = "trend";

    }

    // Journalist Entity SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.JournalistEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistEntitySOVOnline:
                graphs_data = "JournalistClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.JournalistEntitySOVPrint:
                graphs_data = "JournalistClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.JournalistEntitySOVPrintOnline:
                graphs_data = "JournalistClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
        category = "journalist";
        subtype = "journalist";

    }

    // Journalist Entity Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistEntityTonalityOnline:
                graphs_data = "JournalistClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.JournalistEntityTonalityPrint:
                graphs_data = "JournalistClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline:
                graphs_data = "JournalistClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "journalist";
        subtype = "journalist";
        indextype = "tonality"

    }




    // Journalist Keyword Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistKeywordTrendOnline:
                graphs_data = "JournalistClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.JournalistKeywordTrendPrint:
                graphs_data = "JournalistClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline:
                graphs_data = "JournalistClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "journalist";
        subtype = "keywords";
        indextype = "trend";

    }

    // Journalist Keyword SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistKeywordSOVOnline:
                graphs_data = "JournalistClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.JournalistKeywordSOVPrint:
                graphs_data = "JournalistClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline:
                graphs_data = "JournalistClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "journalist";
        subtype = "journalist";
        indextype = "keywords"

    }

    // Journalist Keyword Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.JournalistKeywordTonalityOnline:
                graphs_data = "JournalistClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.JournalistKeywordTonalityPrint:
                graphs_data = "JournalistClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline:
                graphs_data = "JournalistClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize5levelreport;
        category = "journalist";
        subtype = "keywords";
        indextype = "tonality"

    }



    // Keyword Entity Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordEntityTrendOnline:
                graphs_data = "KeywordClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.KeywordEntityTrendPrint:
                graphs_data = "KeywordClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.KeywordEntityTrendPrintOnline:
                graphs_data = "KeywordClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "keywords";
        indextype = "trend";

    }

    // Keyword Entity SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordEntitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordEntitySOVOnline:
                graphs_data = "KeywordClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.KeywordEntitySOVPrint:
                graphs_data = "KeywordClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.KeywordEntitySOVPrintOnline:
                graphs_data = "KeywordClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generalize3levelreport;
        category = "keywords";
        subtype = "keywords";
    }

    // Keyword Entity Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordEntityTonalityOnline:
                graphs_data = "KeywordClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.KeywordEntityTonalityPrint:
                graphs_data = "KeywordClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline:
                graphs_data = "KeywordClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "keywords";
        indextype = "tonality"

    }




    // Keyword Publication Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordPublicationTrendOnline:
                graphs_data = "KeywordClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.KeywordPublicationTrendPrint:
                graphs_data = "KeywordClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline:
                graphs_data = "KeywordClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "publication";
        indextype = "trend";

    }

    // Keyword Publication SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordPublicationSOVOnline:
                graphs_data = "KeywordClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.KeywordPublicationSOVPrint:
                graphs_data = "KeywordClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline:
                graphs_data = "KeywordClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "thematic";
        indextype = "publication"
    }

    // Keyword Publication Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordPublicationTonalityOnline:
                graphs_data = "KeywordClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.KeywordPublicationTonalityPrint:
                graphs_data = "KeywordClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline:
                graphs_data = "KeywordClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "publication";
        indextype = "tonality"

    }



    // Keyword Journalist Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordJournalistTrendOnline:
                graphs_data = "KeywordClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.KeywordJournalistTrendPrint:
                graphs_data = "KeywordClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline:
                graphs_data = "KeywordClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "journalist";
        indextype = "trend";

    }

    // Keyword Journalist SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordJournalistSOVOnline:
                graphs_data = "KeywordClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.KeywordJournalistSOVPrint:
                graphs_data = "KeywordClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline:
                graphs_data = "KeywordClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "journalist";
        indextype = "journalist"
    }

    // Keyword Journalist Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordJournalistTonalityOnline:
                graphs_data = "KeywordClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.KeywordJournalistTonalityPrint:
                graphs_data = "KeywordClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline:
                graphs_data = "KeywordClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "journalist";
        indextype = "tonality"

    }



    // Keyword City Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.KeywordCityTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordCityTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordCityTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordCityTrendOnline:
                graphs_data = "KeywordClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.KeywordCityTrendPrint:
                graphs_data = "KeywordClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.KeywordCityTrendPrintOnline:
                graphs_data = "KeywordClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "city";
        indextype = "trend";

    }

    // Keyword City SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordCitySOVPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordCitySOVOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordCitySOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordCitySOVOnline:
                graphs_data = "KeywordClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.KeywordCitySOVPrint:
                graphs_data = "KeywordClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.KeywordCitySOVPrintOnline:
                graphs_data = "KeywordClientCompetitorSOVprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "city";
        indextype = "city"
    }

    // Keyword City Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordCityTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordCityTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordCityTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordCityTonalityOnline:
                graphs_data = "KeywordClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.KeywordCityTonalityPrint:
                graphs_data = "KeywordClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.KeywordCityTonalityPrintOnline:
                graphs_data = "KeywordClientCompetitorTonalityprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "city";
        indextype = "tonality"

    }



    // Keyword Spokesperson Trend Level

    if (
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTrendPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTrendOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordSpokespersonTrendOnline:
                graphs_data = "KeywordClientCompetitortrendonline";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonTrendPrint:
                graphs_data = "KeywordClientCompetitortrendprint";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline:
                graphs_data = "KeywordClientCompetitortrendprintonline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "spokesperson";
        indextype = "trend";

    }

    // Keyword Spokesperson SOV level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonSOVPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonSOVOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordSpokespersonSOVOnline:
                graphs_data = "KeywordClientCompetitorSOVonline";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonSOVPrint:
                graphs_data = "KeywordClientCompetitorSOVprint";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline:
                graphs_data = "KeywordClientCompetitorSOVprintOnline";
                break;
        }
        url = qualitativeEnvConfig.generaliz4levelreport;
        category = "keywords";
        subtype = "spokesperson";
        indextype = "spokesperson"
    }

    // Keyword Spokesperson Tonality level
    if (
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline ||
        paramGraphData === GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline
    ) {
        switch (paramGraphData) {
            case GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline:
                graphs_data = "KeywordClientCompetitorTonalityonline";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint:
                graphs_data = "KeywordClientCompetitorTonalityprint";
                break;
            case GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline:
                graphs_data = "KeywordClientCompetitorTonalityprintOnline";
                break;
        }
        url = qualitativeEnvConfig.generaliz5levelreport;
        category = "keywords";
        subtype = "spokesperson";
        indextype = "tonality"

    }

    return {
        url,
        graphs_data,
        category,
        subtype,
        indextype,
        extratype,
        media_type,
    }
}